/**
 * Обходит список параллельно, но не больше `limit` задач одновременно, и
 * возвращает результаты В ПОРЯДКЕ ВХОДА.
 *
 * Порядок важен: сбор статистики сортирует публикации по дате и в таком же
 * порядке кладёт их в отчёт. Promise.all по всему списку сразу тоже сохранил бы
 * порядок, но выстрелил бы сотней запросов к Instagram разом и упёрся в лимиты.
 *
 * Ошибка одной задачи не роняет остальные: наверх уходит либо значение, либо
 * ошибка, и вызывающий сам решает, что с ней делать. Глотать её здесь нельзя —
 * именно из-за молчаливого проглатывания публикации пропадали из статистики.
 */
export type Settled<T> = { ok: true; value: T } | { ok: false; error: unknown };

export async function mapWithConcurrency<In, Out>(
  items: readonly In[],
  limit: number,
  task: (item: In, index: number) => Promise<Out>,
  onProgress?: (done: number, total: number) => void,
): Promise<Settled<Out>[]> {
  const results: Settled<Out>[] = new Array(items.length);
  const width = Math.max(1, Math.min(Math.floor(limit) || 1, items.length));
  let cursor = 0;
  let done = 0;

  const worker = async (): Promise<void> => {
    for (;;) {
      const i = cursor++;
      if (i >= items.length) return;
      try {
        results[i] = { ok: true, value: await task(items[i], i) };
      } catch (error) {
        results[i] = { ok: false, error };
      }
      done += 1;
      onProgress?.(done, items.length);
    }
  };

  await Promise.all(Array.from({ length: width }, () => worker()));
  return results;
}
